import React, { useEffect, useRef } from "react";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { IconChevronDown, IconChevronRight, IconGlobe, IconX } from "../../profile/icons";
import "./BurgerMenu.css";

// value уходит в localStorage/i18n как раньше
const LANGS = [
  { value: "ru", label: "Русский" },
  { value: "en", label: "English" },
  { value: "tu", label: "Türkçe" },
];

const BurgerMenu = ({ open, onClose }) => {
  const { t, i18n } = useTranslation();
  const closeRef = useRef(null);

  useEffect(() => {
    if (open) closeRef.current?.focus();
  }, [open]);

  const changeLanguage = (lng) => {
    localStorage.setItem("language", lng);
    i18n.changeLanguage(lng);
    window.location.href = window.location.href; // как и раньше: перезагрузка, чтобы применить язык везде
  };

  return (
    <aside
      className={`fxh-drawer${open ? " open" : ""}`}
      role="dialog"
      aria-modal="true"
      aria-label={t("burger_menu.setting")}
      onClick={(e) => e.stopPropagation()}
    >
      <div className="fxh-dhead">
        <h2>{t("burger_menu.setting")}</h2>
        <button type="button" ref={closeRef} className="fxh-icon-btn" onClick={onClose} aria-label={t("common.close", "Закрыть")}>
          <IconX />
        </button>
      </div>

      <div className="fxh-scroll">
        <div className="fxh-setting">
          <label htmlFor="fxh-lang">{t("burger_menu.language")}</label>
          <span className="fxh-select">
            <IconGlobe />
            <select
              id="fxh-lang"
              value={localStorage.getItem("language") || i18n.language || "ru"}
              onChange={(e) => changeLanguage(e.target.value)}
            >
              {LANGS.map((l) => (
                <option key={l.value} value={l.value}>
                  {l.label}
                </option>
              ))}
            </select>
            <IconChevronDown className="chev" />
          </span>
        </div>

        <nav className="fxh-links" aria-label={t("burger_menu.setting")}>
          <Link to="/policy">
            {t("burger_menu.privacy_policy")}
            <IconChevronRight />
          </Link>
          <Link to="/policy-about">
            {t("burger_menu.about_team")}
            <IconChevronRight />
          </Link>
          <Link to={{ pathname: "/policy-about", hash: "#contacts" }}>
            {t("burger_menu.support")}
            <IconChevronRight />
          </Link>
        </nav>
      </div>
    </aside>
  );
};

export default BurgerMenu;
